"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const urls_1 = __importDefault(require("./urls"));
const ResourceClient_1 = require("./ResourceClient");
const mapDomainResponse = (dm) => ({
    id: dm.id,
    name: dm.name,
    description: dm.description,
    mfaRequired: dm.mfa_required,
    adminProfileId: dm.admin_profile_id,
    createdAt: dm.created_at,
    r: {
        adminProfile: (0, ResourceClient_1.mapResourceProfileResponse)(dm.r.admin_profile),
        profiles: dm.r.profiles.map(ResourceClient_1.mapResourceProfileResponse),
    },
    isMultiTimezoneEnabled: dm.is_multitimezone_enabled,
});
const mapEnterpriseUserResponse = (user) => ({
    id: (user === null || user === void 0 ? void 0 : user.id) || '',
    email: user.email,
    name: user.name,
    domainRole: user.domain_role,
    locations: user === null || user === void 0 ? void 0 : user.locations,
});
const mapDomainUserResponse = (user) => ({
    id: (user === null || user === void 0 ? void 0 : user.id) || '',
    email: user.email,
    name: user.name,
    domainRole: user.domain_role,
    createdAt: user.created_at,
    locations: user === null || user === void 0 ? void 0 : user.locations,
});
const mapPendingDomainUserResponse = (user) => ({
    id: (user === null || user === void 0 ? void 0 : user.id) || '',
    email: user.email,
    name: user.name,
    domainRole: user.domain_role,
    lastSentAt: user.last_send_at,
    locations: user === null || user === void 0 ? void 0 : user.locations,
});
class DomainClient {
    getDomain() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.domain(),
            });
            return data ? mapDomainResponse(data) : null;
        });
    }
    updateDomain(domain) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'PATCH',
                url: urls_1.default.domain(),
                body: {
                    name: domain.name,
                    description: domain.description,
                    mfa_required: domain.mfaRequired,
                },
            });
            return mapDomainResponse(data);
        });
    }
    inviteToDomain(email) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.domainInvite(),
                body: { email },
            });
        });
    }
    setProfileDomainRole(profileId, domainRole) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.domainProfileSetRole(profileId),
                body: { domain_role: domainRole },
            });
            return (0, ResourceClient_1.mapResourceProfileResponse)(data);
        });
    }
    getDomainUsers() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.getDomainUsers(),
            });
            return response.map((user) => mapDomainUserResponse(user));
        });
    }
    getPendingDomainUsers() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.getPendingDomainUsers(),
            });
            return response.map((user) => mapPendingDomainUserResponse(user));
        });
    }
    validateEmail(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.validateEmail(),
                body: { email: data.email },
            });
            return response;
        });
    }
    inviteDomainUser(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.inviteDomainUser(),
                body: {
                    email: data.email,
                    name: data.name,
                    domain_role: data.domainRole,
                    location_ids: data.locationIds,
                },
            });
            return mapEnterpriseUserResponse(response);
        });
    }
    updateDomainInvite(inviteId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.requestProtected({
                method: 'PATCH',
                url: urls_1.default.updateDomainInvite(inviteId),
                body: {
                    domain_role: data.domainRole,
                    location_ids: data.locationIds,
                },
            });
            return mapPendingDomainUserResponse(response);
        });
    }
    resendDomainInvite(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.resendDomainInvite(data.inviteId),
            });
            return mapPendingDomainUserResponse(response);
        });
    }
    cancelDomainInvite(data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestProtected({
                method: 'DELETE',
                url: urls_1.default.cancelDomainInvite(data.inviteId),
            });
        });
    }
    acceptDomainInvite() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.acceptDomainInvite(),
            });
        });
    }
    updateDomainUser(profileId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.requestProtected({
                method: 'PATCH',
                url: urls_1.default.updateDomainUser(profileId),
                body: {
                    name: data.name,
                    domain_role: data.domainRole,
                    location_ids: data.locationIds,
                },
            });
            return mapEnterpriseUserResponse(response);
        });
    }
}
exports.default = DomainClient;
